import MonthlyEntries from "./MonthlyEntries";

export default MonthlyEntries;